import { useEffect, useRef, useState } from "react";

const useLoadingProgress = (active = true) => {
  const [progress, setProgress] = useState(0);
  const progressRef = useRef(0);

  useEffect(() => {
    if (!active) return undefined;

    progressRef.current = 8;
    setProgress(8);

    const interval = window.setInterval(() => {
      if (progressRef.current >= 92) return;

      let step = 4;
      if (progressRef.current >= 70) step = 1;
      else if (progressRef.current >= 45) step = 2;

      progressRef.current = Math.min(progressRef.current + step, 92);
      setProgress(progressRef.current);
    }, 350);

    return () => window.clearInterval(interval);
  }, [active]);

  const completeProgress = () => {
    progressRef.current = 100;
    setProgress(100);
  };

  return { progress, completeProgress };
};

export default useLoadingProgress;
